
// ROUTES
require('modules/archive-media/routes/archive-media');

// CONTROLLERS
require('modules/archive-media/controllers/archive-media');
require('modules/archive-media/controllers/list');

// SERVICES
require('modules/archive-media/services/archive-media');
require('modules/archive-media/services/delete');
require('modules/archive-media/services/list');
require('modules/archive-media/services/edit');


angular.module('unica_archive_media', [

	'infinite-scroll',
	'angular-confirm',
	'bootstrapLightbox',

	// ROUTES
	'unica_archive_media.archive_media_routes',

	// CONTROLLERS
	'unica_archive_media.archive_media_controllers',

	// SERVICES
	'unica_archive_media.archive_media_services'

]);